import React, { useMemo } from 'react';
import { FormControl, FormHelperText, MenuItem } from '@mui/material';

import { StyledSelect } from 'components/Input/styles';

import { getFrequencyOptions, FrequencyType } from '../../utils/rruleUtils';

interface FrequencyPickerProps {
  value: FrequencyType;
  startDate: Date | null;
  zone?: string;
  onChange: (value: FrequencyType) => void;
  error?: boolean;
  helperText?: string;
  enableThreeYearRecurrence?: boolean;
}

const FrequencyPicker: React.FC<FrequencyPickerProps> = ({
  value,
  startDate,
  zone,
  onChange,
  error,
  helperText,
  enableThreeYearRecurrence = false,
}) => {
  const options = useMemo(
    () => getFrequencyOptions(startDate, enableThreeYearRecurrence, zone),
    [startDate, enableThreeYearRecurrence, zone]
  );

  return (
    <FormControl fullWidth error={error} size="medium">
      <StyledSelect value={value} onChange={(event) => onChange(event.target.value as FrequencyType)} displayEmpty>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </StyledSelect>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default FrequencyPicker;
